import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  roomsList: [],
  error: null,
}

const slice = createSlice({
  name: 'roomsList',
  initialState: initialState,
  reducers: {
    getRoomsAction: (state) => {
      state.loading = true
      state.error = null
    },
    setRoomsAction:(state, action)=>{
      state.loading = false
      state.roomsList = action.payload.data.data
      state.error = null
    },
    errorRoomsAction: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.roomsList = []
    },
    roomsResetState: () => initialState,
  },
});

export const {
  getRoomsAction,
  setRoomsAction,
  errorRoomsAction,
  roomsResetState,
} = slice.actions

export default slice.reducer
